controllers.controller('PersonalDetailsController', [
    '$scope', '$state', '$ionicModal', '$ionicLoading', 'LocaleService', 'Validator', 'UserService', 'Storage',
    'Utils', 'API', 'ErrorService', 'constants', 'moment', 'CountryService', 'ProfileRulesHelper',
    function ($scope, $state, $ionicModal, $ionicLoading, LocaleService, Validator, UserService, Storage,
              Utils, API, ErrorService, Const, moment, CountryService, ProfileRulesHelper) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.constants = Const;
        $scope.validator = Validator.getPattern;


        $scope.citizenships = CountryService.getCitizenships();
        $scope.editSensitiveDetails = Utils.toBoolean(Storage.get('editSensitiveDetails'));
        $scope.user = UserService.get();
        $scope.countries = CountryService.getAllowedUserCountries($scope.user.country);
        $scope.profileRulesHelper = new ProfileRulesHelper(Const['profileFieldRules'], 'clientArea');
        $scope.allFieldsAreRequired = !Const['autoUpdatePersonalDetails'];

        $scope.minBirth =  moment().utc().subtract(18, 'y').format("YYYY-MM-DD");

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            isProcess: false
        };
        $scope.modal = angular.copy(modalDefaults);
        $scope.search = {
            country: '',
            citizenship: '',
        };
        $scope.personalProfileForm = {
            firstName: $scope.user.firstName,
            lastName: $scope.user.lastName,
            birthday: ($scope.user.birthday && moment($scope.user.birthday).toDate()) || '',
            phone: $scope.user.phone,
            country: _.find($scope.countries, {code: $scope.user.country}) || '',
            citizenship: _.find($scope.citizenships, {citizenship: $scope.user.citizenship}) || '',//$scope.user.citizenship,
            address: $scope.user.address,
            city: $scope.user.city,
            postCode: $scope.user.postCode
        };
        $scope.personalProfileForm.state = _.find($scope.personalProfileForm.country.states, {stateCode: $scope.user.state});
        $scope.stateName = ($scope.personalProfileForm.state && $scope.personalProfileForm.state.stateName) || '';
        $scope.countryName = $scope.personalProfileForm.country && $scope.personalProfileForm.country.country;
        $scope.citizenshipName = $scope.personalProfileForm.citizenship && $scope.personalProfileForm.citizenship.citizenship;

        $scope.countriesModal = function (type, form) {
            $ionicModal.fromTemplateUrl('templates/countries-select.html', {
                scope: $scope,
                hardwareBackButtonClose: false,
                animation: 'slide-in-up'
            }).then(function (modal) {
                $scope.selectType = type;
                $scope.countriesList = $scope.selectType === 'country' ? $scope.countries : $scope.citizenships;
                $scope.states = $scope.personalProfileForm.country.states || [];
                $scope.countryModal = modal;
                $scope.countryModal.show();
                $scope.FormController = form;
            });
        };

        $scope.closeCountryModal = function () {
            $scope.countryModal && $scope.countryModal.hide();
            $scope.countriesList = null;
            $scope.search = {
                country: '',
                citizenship: '',
            };
        };

        /*$scope.setCountry = function (item) {
            if ($scope.selectType === 'country') {
                $scope.personalProfileForm.country = item;
                $scope.countryName = item.country;

                //reset state on every country change
                $scope.personalProfileForm.state = '';
                $scope.stateName = '';

                if (item.states.length > 0) {
                    //set first state
                    $scope.personalProfileForm.state = item.states[0];
                    $scope.stateName = item.states[0].stateName;
                    $scope.FormController.state.$setDirty();
                }

                $scope.FormController.country.$setDirty();
            }

            if ($scope.selectType === 'citizenship') {
                $scope.personalProfileForm.citizenship = item.citizenship;
                $scope.citizenshipName = item.citizenship;
                $scope.FormController.citizenship.$setDirty();
            }

            if ($scope.selectType === 'state') {
                $scope.personalProfileForm.state = item;
                $scope.stateName = item.stateName;
                $scope.FormController.state.$setDirty();
            }

            $scope.search = {
                country: '',
                citizenship: '',
            };
            $scope.countryModal.hide();
        };*/

        $scope.countryModalConfig = {
            label: 'country',
            id: 'country',
            titleLabel: 'select_country',
            flagLabel: 'code'
        };

        $scope.countryModal = false;

        $scope.openCountryModal = function () {
            $scope.countryModal = true;
        };

        $scope.setCountry = function (country) {
            $scope.countryModal = false;
            $scope.personalProfileForm.country = country;
            if (country.states.length > 0) {
                $scope.countryStates = country.states;
                //set first state
                $scope.personalProfileForm.state = country.states[0];
            }

            $scope.personalProfileForm.country = country;
            $scope.countryName = country.country;

            //reset state on every country change
            $scope.personalProfileForm.state = '';
            $scope.stateName = '';
        };

        $scope.countryStateModalConfig = {
            label: 'stateName',
            id: 'stateCode',
            titleLabel: 'select_state'
        };
        $scope.countryStateModal = false;
        $scope.openCountryStateModal = function () {
            $scope.countryStateModal = true;
        };

        $scope.setCountryState = function (state) {
            $scope.countryStateModal = false;
            $scope.personalProfileForm.state = state;
        };

        $scope.citizenshipModalConfig = {
            label: 'citizenship',
            id: 'citizenship',
            titleLabel: 'select_citizenship'
        };
        $scope.citizenshipModal = false;
        $scope.openCitizenshipModal = function () {
            $scope.citizenshipModal = true;
        };

        $scope.setCitizenship = function (country) {
            $scope.citizenshipModal = false;
            $scope.personalProfileForm.citizenship = country;
        };

        $scope.closeModal = function () {
            $scope.countryModal = false;
            $scope.countryStateModal = false;
            $scope.citizenshipModal = false;
            $scope.taxCountryModal = false;
        };


        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'PersonalDetailsController',
                    type: Const.error.type.VALIDATION,
                    code: data.code || 'updateCustomerFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.updatePersonalDetails = function (form) {
            Utils.formRevalidate(form, true);
            if (!form.$valid) return;
            var request = {
                firstName: $scope.personalProfileForm.firstName,
                lastName: $scope.personalProfileForm.lastName,
                birthday:$scope.personalProfileForm.birthday && moment($scope.personalProfileForm.birthday).format("YYYY-MM-DD") || '',
                country: $scope.personalProfileForm.country.code,
                state: ($scope.personalProfileForm.state && $scope.personalProfileForm.state.stateCode) || '',
                city: $scope.personalProfileForm.city || '',
                address: $scope.personalProfileForm.address || '',
                currency: $scope.user.currency,
                postCode: $scope.personalProfileForm.postCode || '',
                phone: $scope.personalProfileForm.phone,
                citizenship: $scope.personalProfileForm.citizenship.citizenship || '',
                usCitizen: 0,
                usTaxId: '',
                is_pep: $scope.personalProfileForm.pep || 0,
                tin_absence_reason: $scope.personalProfileForm.tinAbsenceReason || ''
            };

            if (!request.citizenship && !$scope.allFieldsAreRequired) {
                request.citizenship = ($scope.citizenships.find(function (citizenship) {
                    return citizenship.code === request.country
                }) || {}).citizenship;
            }

            $ionicLoading.show();

            return API.updatePersonalDetails(request)
                .then(checkResponse)
                .then(function () {
                    Storage.load(['withdrawalMethods','localBanks'])
                    $scope.user.updatePersonalDetails(request);
                    $ionicLoading.hide();
                    $scope.modal.isError = false;
                    $scope.modal.isProcess = false;
                    $scope.modal.textTitle = LocaleService.translation.messages.updateCustomerSuccess;
                    $scope.modal.back = "root.app.menu";
                    $scope.modal.actionText = LocaleService.translation.back;
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && error.code && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = "";
                    $scope.modal.back = "root.app.menu";
                    $scope.modal.actionText = LocaleService.translation.try_again;
                    $scope.modal.state = true;
                })

        };

        $scope.$on('$ionicView.beforeEnter', function () {
            if ($scope.user && !$scope.user.tnc && Const['tncPopup']) {
                return $state.go('tnc', {cache: false});
            }
            if ($scope.user) {
                switch ($scope.user.registrationState) {
                case Const.userState.initial:
                    return $state.go('signupPersonalProfile', {cache: false});
                case Const.userState.personal:
                    return $state.go('signupQuestionnaire', {cache: false});
                }
            }
            return UserService.kycCheck();
        });

        $scope.$on('$ionicView.afterLeave', function (event) {
            $scope.countryModal && $scope.countryModal.hide() && $scope.countryModal.remove();
        });
    }]);
